var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellFill24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C12.8284 5.25 13.5 4.57843 13.5 3.75C13.5 2.92157 12.8284 2.25 12 2.25C11.1716 2.25 10.5 2.92157 10.5 3.75C10.5 4.57843 11.1716 5.25 12 5.25Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.75H3V15H3.75C4.575 15 5.25 14.325 5.25 13.5V11.25C5.25 7.5 8.25 4.5 12 4.5C15.75 4.5 18.75 7.5 18.75 11.25V13.5C18.75 14.325 19.425 15 20.25 15H21V18.75ZM12 23.25C13.8 23.25 15.3 21.975 15.675 20.25H8.325C8.7 21.975 10.2 23.25 12 23.25ZM7.5 13.5C7.5 13.95 7.8 14.25 8.25 14.25C8.7 14.25 9 13.95 9 13.5C9 13.05 8.7 12.75 8.25 12.75C7.8 12.75 7.5 13.05 7.5 13.5ZM11.25 9V7.5C9.45 7.5 7.5 9 7.5 11.25H9C9 9.9 10.2 9 11.25 9Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFill24);
export default __webpack_public_path__ + "static/media/BellFill-24.adcbe26e.svg";
export { ForwardRef as ReactComponent };